import { Component, computed, input, signal } from '@angular/core';

import { ModalNotificationHeaderComponent } from '../header/modal-notification-header.component';
import { ModalNotificationFooterComponent } from '../footer/modal-notification-footer.component';
import { ModalNotificationWelcomeModalDiComponent } from './welcome-modal-di/modal-notification-welcome-modal-di.component';
import { ModalNotificationWelcomeModalFpPiaComponent } from './welcome-modal-fp-pia/modal-notification-welcome-modal-fp-pia.component';

@Component({
  imports: [
    ModalNotificationHeaderComponent,
    ModalNotificationFooterComponent,
    ModalNotificationWelcomeModalDiComponent,
    ModalNotificationWelcomeModalFpPiaComponent
  ],
  selector: 'td-wb-modal-notification-welcome',
  templateUrl: 'modal-notification-welcome.component.html'
})
export class ModalNotificationWelcomeComponent {
  readonly modalId = input('');
  protected readonly currentPage = signal(0);
  protected readonly isDiWelcomeModal = computed(() => this.modalId() === 'welcome_modal_di');
  protected readonly isFpPiaWelcomeModal = computed(() => this.modalId() === 'welcome_modal_fp_pia');

  protected goToSelected(step: number): void {
    this.currentPage.set(step);
  }
}
